import { render, staticRenderFns } from "./SearchHistoryRemoveModal.vue?vue&type=template&id=af14896a&scoped=true&"
import script from "./SearchHistoryRemoveModal.vue?vue&type=script&lang=ts&"
export * from "./SearchHistoryRemoveModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af14896a",
  null
  
)

export default component.exports